// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"tree-square-dot"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M9.5 3H14.5V8H9.5V3Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M16 16H21V21H16V16Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M3 16H8V21H3V16Z"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12 8V12.3333M12 12.3333H5.5V16M12 12.3333H18.5V16M9.5 3H14.5V8H9.5V3ZM16 16H21V21H16V16ZM3 16H8V21H3V16Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const TreeSquareDotIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'tree-square-dot',
    ref,
    icon: element,
  },
));

TreeSquareDotIcon.displayName = 'TreeSquareDotIcon';

export default TreeSquareDotIcon;
